import { memo } from 'react';

import { ChessBoard } from '@exports/ChessBoard';

import { Label, VerticalRadio } from './SimpleControls';

import styles from './PopupControls.module.css';

export interface ICatalogGroup {
  title: string;
  positions: ICatalogPosition[];
}

export interface ICatalogPosition {
  title: string;
  value: string;
}

export const PositionsCatalog = memo(function PositionsCatalog({
  catalog,
  selected,
  onChange,
}: {
  catalog: ICatalogGroup[];
  selected?: string;
  onChange?: (o: ICatalogPosition) => void;
}) {
  return (
    <section className={styles.positions_catalog}>
      <div className={styles.positions_catalog__groups}>
        {catalog.map((g) => (
          <div key={g.title}>
            <Label>{g.title}</Label>
            <VerticalRadio options={g.positions} selected={selected} onChange={onChange} />
          </div>
        ))}
      </div>
      <ChessBoard orientation="white" theme="classic-lite" notation="none" position={selected} />
    </section>
  );
});
